import { useState, ImgHTMLAttributes } from "react";
import defaultLogo from "@/assets/patakare-brand-logo-v2.png";

interface LogoImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  logoUrl?: string;
  fallbackSrc?: string;
  preferProvidedLogo?: boolean;
}

const LogoImage = ({ logoUrl, fallbackSrc, preferProvidedLogo = false, alt = "Patakare", style, className = "", ...props }: LogoImageProps) => {
  const [errCount, setErrCount] = useState(0);

  const effectiveUrl = preferProvidedLogo ? logoUrl || null : null;

  const buildFallbacks = (url?: string): string[] => {
    if (!url) return [];
    const mediaDomain = import.meta.env.VITE_MEDIA_DOMAIN || 'www.patakare.com';
    const apiDomain = import.meta.env.VITE_API_DOMAIN || 'www.patakare.com';
    const extras: string[] = [];
    if (url.includes(mediaDomain)) {
      extras.push(url.replace(mediaDomain, apiDomain));
    }
    if (url.includes('/uploaded_files/') && !url.includes('/api/uploaded_files/')) {
      extras.push(url.replace('/uploaded_files/', '/api/uploaded_files/'));
    }
    if (url.includes('/api/uploaded_files/')) {
      extras.push(url.replace('/api/uploaded_files/', '/uploaded_files/'));
    }
    if (url.includes(mediaDomain) && !url.includes('/api/uploaded_files/')) {
      extras.push(url.replace(mediaDomain, apiDomain).replace('/uploaded_files/', '/api/uploaded_files/'));
    }
    return extras;
  };

  const srcs: string[] = [];
  if (effectiveUrl) {
    srcs.push(effectiveUrl);
    srcs.push(...buildFallbacks(effectiveUrl));
  }
  srcs.push(defaultLogo);
  srcs.push("/patakare-brand-logo-v2.png");

  const uniqueSrcs = [...new Set(srcs.filter(Boolean))];
  const currentSrc = uniqueSrcs[Math.min(errCount, uniqueSrcs.length - 1)];

  return (
    <img
      {...props}
      src={currentSrc}
      alt={alt}
      style={{
        imageRendering: 'auto',
        ...style,
      }}
      className={`${className}`}
      onError={() => {
        if (errCount < uniqueSrcs.length - 1) {
          setErrCount(prev => prev + 1);
        }
      }}
    />
  );
};

export default LogoImage;
